import axios from "axios";

function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

export async function registerBoaruaPush(options: { requestPermission?: boolean } = {}) {
  const publicKey = process.env.VUE_APP_WEB_PUSH_PUBLIC_KEY;
  const shouldRequestPermission = options.requestPermission !== false;

  if (localStorage.getItem("boaruaBackofficePushDisabled") === "true") {
    return false;
  }

  if (!("Notification" in window) || !publicKey || !("serviceWorker" in navigator) || !("PushManager" in window)) {
    return false;
  }

  if (Notification.permission === "denied") {
    return false;
  }

  const permission = Notification.permission === "granted"
    ? "granted"
    : shouldRequestPermission
      ? await Notification.requestPermission()
      : Notification.permission;

  if (permission !== "granted") {
    return false;
  }

  const registration = await navigator.serviceWorker.register("/boarua-push-sw.js");
  let subscription = await registration.pushManager.getSubscription();

  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }

  await axios.post("/notification-subscriptions", {
    ...subscription.toJSON(),
    platform: "backoffice",
  });

  return true;
}
